import { createSelector } from 'reselect';
import { getOperators } from './getOperators';

const getUnattendedOperator = createSelector([getOperators], (operators) => {
  return (
    operators.find((op) => {
      return op.name === 'Unattended';
    }) || null
  );
});

export { getUnattendedOperator };
